/* PP — Hero 3D peel (2026-09-02)
   Builds a bendable DTF film sheet out of nested strips and runs a looping story:
   rest → hot-peel from the bottom edge upward → pull the sheet away → lay a fresh sheet down → rest.
   Strip i (0 = top, anchored) is nested inside strip i-1 and rotates on its own top
   edge, so rotations accumulate down the chain and the sheet curls like real film.
   Pauses off-screen, honours prefers-reduced-motion (static half-peeled pose). */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(x,a,b){ return x<a?a:(x>b?b:x); }
  function smooth(a,b,x){ var t=clamp((x-a)/(b-a),0,1); return t*t*(3-2*t); }
  function easeInOut(t){ return t<.5 ? 4*t*t*t : 1-Math.pow(-2*t+2,3)/2; }
  function easeIn(t){ return t*t*t; }
  function easeOut(t){ return 1-Math.pow(1-t,3); }

  function init(root){
    if(root.dataset.peelInit) return; root.dataset.peelInit='1';
    var N = parseInt(root.dataset.strips||'16',10);
    var shadow = document.createElement('div'); shadow.className='pph3-peel-shadow';
    var sheet  = document.createElement('div'); sheet.className='pph3-peel-sheet';
    root.appendChild(shadow); root.appendChild(sheet);
    var strips=[], parent=sheet;
    for(var i=0;i<N;i++){
      var s=document.createElement('div'); s.className='pph3-ps'+(i===0?' pph3-ps--first':'')+(i===N-1?' pph3-ps--last':'');
      s.style.setProperty('--k', String(i));
      parent.appendChild(s); strips.push(s); parent=s;
    }
    function size(){ var h=sheet.offsetHeight||1; root.style.setProperty('--sh',(h/N).toFixed(3)+'px'); }
    size();
    if('ResizeObserver' in window){ new ResizeObserver(size).observe(sheet); } else { window.addEventListener('resize', size); }

    /* per-strip bend (degrees) as a function of distance above the peel line:
       steep near the line, then a long gentle tail so the peeled part curls back on itself */
    function bend(d){ return 34*smooth(-1,.7,d) - 27.5*smooth(2.2,3.6,d); }

    function pose(L, sway, glintAt){
      var lifted = 0;
      for(var i=0;i<N;i++){
        var d = i - L, a = bend(d);
        if(sway) a *= 1 + .05*Math.sin(sway + i*.35);
        var st = strips[i].style;
        st.transform = 'rotateX(' + a.toFixed(2) + 'deg)';
        st.setProperty('--lit', clamp(a/34,0,1).toFixed(3));
        st.setProperty('--glint', glintAt==null ? '0' : clamp(1-Math.abs(i-glintAt)/1.4,0,1).toFixed(3));
        if(a>4) lifted++;
      }
      var peeled = clamp((N-L)/N,0,1);
      shadow.style.clipPath = 'inset(' + ((1-peeled)*100).toFixed(2) + '% 0 0 0)';
      shadow.style.opacity = (peeled*.75).toFixed(3);
    }
    function move(tx,ty,tz,rx,sc){
      root.style.transform = 'rotate(var(--frot,0deg)) translate3d(' + tx.toFixed(1) + '%,' + ty.toFixed(1) + '%,' + tz.toFixed(1) + 'px) rotateX(' + rx.toFixed(1) + 'deg) scale(' + sc.toFixed(3) + ')';
    }

    if(reduce){ pose(N*.55, 0, null); move(0,0,4,0,1); return; }

    /* timeline (seconds) */
    var T_REST=1.1, T_PEEL=2.6, T_HOLD=.9, T_AWAY=.55, T_GAP=.25, T_LAY=.8;
    var TOTAL = T_REST+T_PEEL+T_HOLD+T_AWAY+T_GAP+T_LAY;
    var running=false, id=null, t0=null;
    function frame(now){
      if(!running) return;
      if(t0===null) t0=now;
      var t = ((now-t0)/1000) % TOTAL, p;
      if(t < T_REST){ pose(N,0,null); move(0,0,4,0,1); }
      else if((t-=T_REST) < T_PEEL){ p=easeInOut(t/T_PEEL); var L=N*(1-p); pose(L,0,L); move(0,0,4,0,1); }
      else if((t-=T_PEEL) < T_HOLD){ pose(0, now/380, null); move(0,0,4,0,1); }
      else if((t-=T_HOLD) < T_AWAY){ p=easeIn(t/T_AWAY); pose(0,0,null); move(45*p, -170*p, 4+260*p, -28*p, 1-.72*p); shadow.style.opacity=(0.75*(1-p)).toFixed(3); }
      else if((t-=T_AWAY) < T_GAP){ pose(N,0,null); move(-30,-180,260,-40,.25); shadow.style.opacity='0'; }
      else { p=easeOut((t-T_GAP)/T_LAY); pose(N,0,null); move(-30*(1-p), -180*(1-p), 4+256*(1-p), -40*(1-p), .25+.75*p); shadow.style.opacity=(0.35*(1-p)).toFixed(3); }
      id=requestAnimationFrame(frame);
    }
    function start(){ if(running) return; running=true; t0=null; id=requestAnimationFrame(frame); }
    function stop(){ running=false; if(id) cancelAnimationFrame(id); id=null; }
    pose(N,0,null); move(0,0,4,0,1);
    if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ es.forEach(function(e){ e.isIntersecting?start():stop(); }); },{threshold:.05}).observe(root.closest('.pph3') || root.parentElement || root); } else { start(); }
    document.addEventListener('visibilitychange', function(){ if(document.hidden) stop(); });
  }
  function boot(){ document.querySelectorAll('.pph3-peel').forEach(init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
